import MuiList from '@material-ui/core/List';

export default MuiList;
